import { Loader2 } from "lucide-react";
import { t, useLocale } from "@/i18n/locale";

/**
 * Placeholder for a view that is still loading: a centred spinner in the
 * space the view will occupy. The label is announced, not shown.
 */
export default function LoadingView({ label = "Loading…" }: { label?: string }) {
  useLocale();
  return (
    <div className="loading-view" role="status">
      <Loader2 className="loading-view-spinner" size={24} aria-hidden="true" />
      <span className="loading-view-label">{t(label)}</span>
    </div>
  );
}
